module.exports = {"heading":"Case","filter":{"type":"Type","client":"Client","during":"During"},"detail":{"address":"address","amount":"amount","client":"client","during":"during","intro":"intro","organizer":"organizer","type":"type"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/CasePage/locale/en.json
// module id = 889
// module chunks = 0